import React from 'react';

const HeaderRight = ({ children }) => <div className="ws-ui-editor-header__right">{children}</div>;

export default HeaderRight;
